import { Section } from './section';
import { Main, Content } from './main';
import { LayoutSection } from '../core/layout-section';

// ----------------------------------------------------------------------

// Form on the left, figure on the right, and no header at all: the brand sits inside the form
// column, so a top bar would only have added an empty 64px band above a vertically centred page.
export function AuthSplitLayout({ sx, children }) {
  const layoutQuery = 'md';

  return (
    <LayoutSection
      headerSection={null}
      footerSection={null}
      sx={sx}
      cssVars={{ '--layout-auth-content-width': '380px' }}
    >
      <Main layoutQuery={layoutQuery}>
        <Content layoutQuery={layoutQuery} sx={{ bgcolor: 'background.neutral' }}>
          {children}
        </Content>

        <Section layoutQuery={layoutQuery} />
      </Main>
    </LayoutSection>
  );
}
